import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import {
  ACTION,
  PROVIDER,
  VIEWER_SIDEBAR_TAB,
} from 'Pods/ThreeDStudio/Store/constants'

import { getModelFormatOutput } from './getModelFormatOutput'

// The backend stores the connector dimensions as decimals, which serialize as strings.
const toNumber = value => (value == null || value === '' ? undefined : Number(value))

const definedEntries = settings => Object.fromEntries(
  Object.entries(settings).filter(([, value]) => value !== undefined && value !== null),
)

/**
 * Builds the ThreeDStudio store patch for a Meshy Auto Split
 * (mesh-segmentation-pro) run. Restores the split settings into segmentSettings,
 * loads the output model and opens the viewer sidebar on the SEGMENT tab.
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} parsedData - ThreeDStudio store patch
 */
export const parseMeshyMeshSegmentationProData = (openedModel) => {
  const {
    id: sessionId,
    modelFormatOutput: rawModelFormatOutput,
    generatorSessionId,
    outputAssets,
    prompt,
    providerRunAttributes = {},
  } = openedModel
  const {
    assetId: inputThreeD,
    fileUrl: inputThreeDUrl,
  } = getAssetByTypeAndSource(outputAssets, '3d_model', 'ai_generated')
  const modelFormatOutput = getModelFormatOutput({
    modelFormatOutput: rawModelFormatOutput,
    modelUrl: inputThreeDUrl,
  })
  const attrs = providerRunAttributes || {}

  const schema = { enhancedAction: ACTION.MESH_SEGMENTATION, enhancedProvider: PROVIDER.MESHY }
  const generation = { sessionId, generatorSessionId }
  const viewer = { fileFormat: modelFormatOutput, inputThreeD }
  const segmentSettings = definedEntries({
    isAutoSplit: true,
    splitMode: attrs.split_mode ?? attrs.splitMode,
    prompt: prompt || undefined,
    layout: attrs.layout,
    connectors: attrs.connectors,
    connectorType: attrs.connector_type ?? attrs.connectorType,
    connectorSize: toNumber(attrs.connector_size ?? attrs.connectorSize),
    connectorHeight: toNumber(attrs.connector_height ?? attrs.connectorHeight),
  })
  const ui = {
    isModelSettingsOpen: false,
    isViewerSidebarOpen: true,
    activeViewerSidebarTab: VIEWER_SIDEBAR_TAB.SEGMENT,
  }

  return {
    openedModel,
    schema,
    ui,
    generation,
    viewer,
    segmentSettings,
  }
}
